<template>
  <div class="grid-y flex-grow divide-y">
    <div class="flex-shrink-0 container-tabs padding-horizontal-2 flex flex-row justify-between">
      <RouterTabs :tabs="tabs"/>
    </div>
    <div class="cell auto flex">
      <div class="grid-x flex-grow">
        <div class="cell auto cell-block-y flex flex-grow">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouterTabs from '@/components/RouterTabs.vue';

export default {
  components: {
    RouterTabs,
  },
  data() {
    return {
      tabs: [
        { title: 'Регистрация', push: { name: 'contractors.requests.registration' } },
        { title: 'Изменение', push: { name: 'contractors.requests.change' } },
      ],
    };
  },
};
</script>
